import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import { initTooltips } from '@/js/modules/tooltips';

onPageLoad(() => {
  initTooltips(document.querySelectorAll('.tooltip'));

  // Init tooltips for all modals on open
  $(document).on($.modal.OPEN, (e) => {
    initTooltips($(e.target).find('.tooltip'));
  });

  // Init tooltips for elements added via Turbo
  document.addEventListener('turbo:after-stream-render', () => {
    initTooltips(document.querySelectorAll('.tooltip'));
  });
});
